'use client'
import React from 'react'
import { MessikaDrawer } from './MessikaDrawer'
import { useHeaderState } from './HeaderContext'

type Props = {
  topMenu: React.ReactNode
  bottomMenu: React.ReactNode
}

export function MainNavigationDrawer(props: Props) {
  const { topMenu, bottomMenu } = props
  const ns = 'main-navigation'
  const [headerState, setHeaderState] = useHeaderState()

  return (
    <MessikaDrawer
      isTransitioning={headerState.isTransitioning}
      open={headerState.isOpen}
      onClose={() => setHeaderState((prev) => ({ ...prev, isOpen: false }))}
      anchor='left'
      id={`${ns}-drawer`}
      classes={{
        dialog: `fixed top-0 lg:top-23 start-0 w-full h-full lg:h-[calc(100%-92px)] z-40 bg-transparent`,
        header: 'lg:hidden p-8 flex-none relative order-1 lg:order-0',
        panel:
          'bg-white w-full lg:min-w-[540px] lg:w-1/3 lg:max-w-screen-sm h-full overflow-hidden transition-all duration-300 flex flex-col flex-none',
      }}>
      <div className='relative h-full w-full overflow-x-hidden'>
        <nav className='h-full flex flex-col overflow-auto'>
          {topMenu}
          <div className='border-solid border-t border-t-black/15 py-1.5 mx-8 lg:mx-20' />
          {bottomMenu}
        </nav>
      </div>
    </MessikaDrawer>
  )
}
